import * as actionTypes from './actionTypes';

const initialState = {
  isOpen: false,
  activeTrail: [],
  mobile: {
    isOpen: false,
  },
  isMobile: window.innerWidth <= 760,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GO_BACK:
      return {
        ...state,
        activeTrail: state.activeTrail.slice(0, state.activeTrail.length - action.amount),
      };

    case actionTypes.SET_ACTIVE_TRAIL:
      return {
        ...state,
        activeTrail: action.activeTrail,
      };

    case actionTypes.ADD_TO_ACTIVE_TRAIL:
      if (action.replaceCurrent) {
        return {
          ...state,
          activeTrail: [...state.activeTrail.slice(0, state.activeTrail.length - 1), action.key],
        };
      }
      return {
        ...state,
        // Add the key if it is not already in the active trail
        activeTrail: state.activeTrail.includes(action.key)
          ? [...state.activeTrail]
          : [...state.activeTrail, action.key],
      };

    case actionTypes.TOGGLE_SUBMENU:
      return {
        ...state,
        isOpen: !state.isOpen,
      };

    case actionTypes.SET_IS_OPEN:
      return {
        ...state,
        isOpen: action.isOpen,
      };

    case actionTypes.TOGGLE_MOBILE_MENU:
      return {
        ...state,
        mobile: {
          isOpen: !state.mobile.isOpen,
        },
      };

    default:
      return state;
  }
};
